// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3642":"b85ee79c","8233":"7b9d31a7","39029":"4766de1e","40263":"dda729b1","80289":"4766de1e","98730":"05a1faa3"}[chunkId] + ".chunk.css";
};